<template>
  <div>
    <!-- 页脚 -->
    <footer id="contact">
      <div class="container">
        <div class="footer-content">
          <div class="footer-column">
            <h3>山东旭辉法律咨询</h3>
            <p>专业法律咨询服务，守护企业合法权益。我们致力于为客户提供全方位、高质量的法律解决方案。</p>
            <div class="contact-info">
              <div class="contact-icon">
                <i class="el-icon-location"></i>
              </div>
              <p>山东潍坊银泉广场6栋24楼·山东旭辉法律咨询有限公司</p>
            </div>
          </div>

          <div class="footer-column">
            <h3>联系我们</h3>
            <div class="contact-info">
              <div class="contact-icon">
                <i class="el-icon-phone"></i>
              </div>
              <p>咨询热线：{{ info.CustomServiceTel }}</p>
            </div>
            <!--<div class="contact-info">-->
              <!--<div class="contact-icon">-->
                <!--<i class="fas fa-fax"></i>-->
              <!--</div>-->
              <!--<p>传真：0531-8888 6667</p>-->
            <!--</div>-->
            <div class="contact-info">
              <div class="contact-icon">
                <i class="el-icon-s-platform"></i>
              </div>
              <p>邮箱：xhfl1408@qq.com</p>
            </div>
          </div>

          <div class="footer-column">
            <h3>快速链接</h3>
            <a href="#home">首页</a>
            <a href="#services">服务项目</a>
            <a href="#about">关于我们</a>
            <a href="#advantages">核心优势</a>
          </div>

          <div class="footer-column">
            <h3>办公时间</h3>
            <p>周一至周六{{ info.CustomServiceDate }}</p>
            <p>周日及法定节假日休息</p>
            <p>紧急情况可预约非工作时间服务</p>
          </div>
        </div>

        <div class="copyright">
          <p>Copyright &copy; 2026 山东旭辉法律咨询有限公司 版权所有 鲁ICP备12345678号</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
    export default {
        data() {
            return {
              url:{
                GetSysData: SZH.assets.api + '/Custom/GetSysData',
              },
              info:{

              }
            }
        },
        methods: {
          getUser(){
            let self = this;
            self.$http.post(self.url.GetSysData,{})
              .then(result => {
                if (result.state == true) {
                  self.info = result.data;
                } else {
                  self.info = {};
                  self.$message.error(result.message);
                }
              }, () => {
                self.loading = false;
                // 请求失败
                self.$message.error('登录失败，请检查您的网络是否可用。');
              });
          },
        },
        computed: {},
        components: {},
        mounted() {
          this.getUser();
        },
    }
</script>

<style scoped>
  /* 页脚样式 */
  footer {
    background-color: #1a3a6c;
    color: white;
    padding: 70px 0 30px;
  }

  .footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
    margin-bottom: 50px;
  }

  .footer-column h3 {
    font-size: 1.5rem;
    margin-bottom: 25px;
    color: #e6a23c;
    position: relative;
    padding-bottom: 10px;
  }

  .footer-column h3::after {
    content: '';
    position: absolute;
    width: 50px;
    height: 2px;
    background-color: #e6a23c;
    bottom: 0;
    left: 0;
  }

  .footer-column p, .footer-column a {
    color: #d0d7e2;
    margin-bottom: 10px;
    display: block;
    text-decoration: none;
    transition: color 0.3s;
  }

  .footer-column a:hover {
    color: #e6a23c;
  }

  .contact-info {
    display: flex;
    align-items: flex-start;
    margin-bottom: 15px;
  }

  .contact-icon {
    margin-right: 10px;
    color: #e6a23c;
  }

  .copyright {
    text-align: center;
    padding-top: 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    color: #d0d7e2;
    font-size: 0.9rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterB/FooterB.vue